import React from 'react';
import Img from 'gatsby-image';
import styled from 'styled-components';
import Link from 'gatsby-link';
import PropTypes from 'prop-types';

const CategoryItem = styled.div`
  box-shadow: ${props => props.theme.shadow};
  margin: 0;
  overflow: hidden;
  position: relative;
  z-index: 2;
  min-height: 200px;
  padding: 0 0 1rem;
  &:hover {
    transform: scale(1.05);
  }
  h3 {
    margin: 0px;
    overflow: hidden;
    position: absolute;
    z-index: 2;
    padding: 10px;
    bottom: 0;
    left: 0;
    font-size: 0.9rem;
    letter-spacing: 0.04rem;
    background: ${props => props.theme.secondaryColor};
    color: ${props => props.theme.white};
  }
`;
/**
 * Provides a simple gallery display similar to a card with a image and a title encased in blue text
 */
function Category(props) {
  return (
    <CategoryItem>
      <Link to={props.url}>
        <Img
          fluid={props.fluid}
          alt={props.alt}
          loading="lazy"
          style={{
            position: 'absolute',
            left: 0,
            top: 0,
            width: '100%',
            height: '100%',
            overflow: 'hidden',
            zIndex: 1
          }}
        />
        <h3>{props.title}</h3>
      </Link>
    </CategoryItem>
  );
}

Category.propTypes = {
  /** URL prop allows linking fom image card using gatsby Link */
  url: PropTypes.string.isRequired,
  /** Is the text in the h3 element with blue background */
  title: PropTypes.string.isRequired,
  /** Is the object from dato cms containing all the images required for Srcest */
  fluid: PropTypes.object.isRequired,
  /** The alt tag of the image required for SEO purposes */
  alt: PropTypes.string.isRequired
};

export { Category };
